export enum ProductTaxable {
  yes = 'true',
  no = 'false'
}
export enum ProductStatus {
  published = 'published',
  outOfStock = 'outOfStock'
}
